module.exports = __webpack_public_path__ + "static/media/mobileDevelopment.3c868c75.svg";